import administrationService from '../services/administration.service';

export const administration = {
  state: {
    instrumentTypes: [],
    counterpartyLimits: [],
    counterparties: [],
    dealerLimits: [],
    taxRates: [],
    taxes: [],
    mmRates: [],
    fees: [],
    clients: [],
    clientSignatories: [],
    clientAccounts: [],
    clientContacts: [],
    kycDocuments: [],
    comDocuments: [],
    decDocuments: [],
    indDocuments: [],
    parDocuments: [],
    penDocuments: [],
    truDocuments: [],
    rdcDocuments: [],
    ptlDocuments: [],
    munDocuments: [],
    ngoDocuments: [],
    ccoDocuments: [],
    fundAccountTypes: [],
    applicationModules: [],
    applicationFunctions: [],
    stockExchanges: [],
    transactionCharges: [],
    custodians: [],
    profileTypes: [],
    applicationEvents: [],
    eventMappings: [],
    transactionchargerates: [],
    equities: [],
    equityprices: [],
    unlistedEquities: [],
    unlistedEquityPrices: [],
    bonds: [],
    properties: [],
    propertyValues: [],
    dailyExchanges: [],
    confirmation_settings: [],
    dealers: [],
    unitTrustFunds: [],
    unitTrustDeals: [],
    unitDistributions: []
  },

//********************************************************************GETTERS*****************************************************************************************
//********************************************************************************************************************************************************************

  getters: {
    allInstrumentTypes: (state) => state.instrumentTypes,
    allKYCDocs: (state) => state.kycDocuments,
    allComDocuments: (state) => state.comDocuments,
    allDecDocuments: (state) => state.decDocuments,
    allIndDocuments: (state) => state.indDocuments,
    allParDocuments: (state) => state.parDocuments,
    allPenDocuments: (state) => state.penDocuments,
    allTruDocuments: (state) => state.truDocuments,
    allRDCDocuments: (state) => state.rdcDocuments,
    allPtlDocuments: (state) => state.ptlDocuments,
    allMunDocuments: (state) => state.munDocuments,
    allNGODocuments: (state) => state.ngoDocuments,
    allCCODocuments: (state) => state.ccoDocuments,
    unconfirmedInstrumentTypes: (state) => {return [state.instrumentTypes.filter(i => i.CheckerID == 0),[state.instrumentTypes.title = "Instrument Types"]]},
    allCounterpartyLimits: (state) => state.counterpartyLimits,
    unconfirmedCounterpartyLimits: (state) => {return [state.counterpartyLimits.filter(c => c.CheckerID == 0),[state.counterpartyLimits.title = "Counterparty Limits"]]},
    allCounterparties: (state) => state.counterparties,
    unconfirmedCounterparties: (state) => {return [state.counterparties.filter(c => c.CheckerID == 0),[state.counterparties.title = "Counterparties"]]},
    allDealerLimits: (state) => state.dealerLimits,
    unconfirmedDealerLimits: (state) => {return [state.dealerLimits.filter(d => d.CheckerID == 0),[state.dealerLimits.title = "Dealer Limits"]]},
    allTaxRates: (state) => state.taxRates,
    unconfirmedTaxRates: (state) => {return [state.taxRates.filter(t => t.CheckerID == 0),[state.taxRates.title = "Tax Rates"]]},
    allTaxes: (state) => state.taxes,
    unconfirmedTaxes: (state) => {return [state.taxes.filter(t => t.CheckerID == 0),[state.taxes.title = "Taxes"]]},
    allMMRates: (state) => state.mmRates,
    unconfirmedMMRates: (state) => {return [state.mmRates.filter(t => t.CheckerID == 0),[state.mmRates.title = "Money Market Rates"]]},
    allFees: (state) => state.fees,
    unconfirmedFees: (state) => {return [state.fees.filter(f => f.CheckerID == 0),[state.fees.title = "Fees Management"]]},
    allClients: (state) => state.clients,
    unconfirmedClients: (state) => {return [state.clients.filter(c => c.CheckerID == 0),[state.clients.title = "Clients"]]},
    allClientSignatories: (state) => state.clientSignatories,
    unconfirmedClientSignatories: (state) => {return [state.clientSignatories.filter(c => c.CheckerID == 0),[state.clientSignatories.title = "Client Signatories"]]},
    allClientAccounts: (state) => state.clientAccounts,
    unconfirmedClientAccounts: (state) => {return [state.clientAccounts.filter(c => c.CheckerID == 0),[state.clientAccounts.title = "Client Accounts"]]},
    allClientContacts: (state) => state.clientContacts,
    unconfirmedClientContacts: (state) => {return [state.clientContacts.filter(c => c.CheckerID == 0),[state.clientContacts.title = "Client Contacts"]]},
    allFundAccountTypes: (state) => state.fundAccountTypes,
    allApplicationModules: (state) => state.applicationModules,
    unconfirmedApplicationModules: (state) => {return [state.applicationModules.filter(a => a.CheckerID == 0),[state.applicationModules.title = "Application Modules"]]},
    allApplicationFunctions: (state) => state.applicationFunctions,
    allStockExchanges: (state) => state.stockExchanges,
    allTransactionCharges: (state) => state.transactionCharges,
    unconfirmedTransactionCharges: (state) => {return [state.transactionCharges.filter(a => a.CheckerID == 0),[state.transactionCharges.title = "Transaction Charges"]]},
    allCustodians: (state) => state.custodians,
    unconfirmedCustodians: (state) => {return [state.custodians.filter(a => a.CheckerID == 0),[state.custodians.title = "Custodians"]]},
    allProfileTypes: (state) => state.profileTypes,
    allApplicationEvents: (state) => state.applicationEvents,
    unconfirmedApplicationEvents: (state) => {return [state.applicationEvents.filter(a => a.CheckerID == 0),[state.applicationEvents.title = "Application Events"]]},
    allEventMappings: (state) => state.eventMappings,
    unconfirmedEventMappings: (state) => {return [state.eventMappings.filter(e => e.CheckerID == 0),[state.eventMappings.title = "Charge Mappings"]]},
    allTransactionchargerates: (state) => state.transactionchargerates,
    unconfirmedTransactionchargerates: (state) => {return [state.transactionchargerates.filter(e => e.CheckerID == 0),[state.transactionchargerates.title = "Transaction Charge Rates"]]},
    allequities: (state) => state.equities,
    unconfirmedEquities: (state) => {return [state.equities.filter(e => e.CheckerID == 0),[state.equities.title = "Equities"]]},
    allequityprices: (state) => state.equityprices,
    allulequities: (state) => state.unlistedEquities,
    unconfirmedUlEquities: (state) => {return [state.unlistedEquities.filter(e => e.CheckerID == 0),[state.unlistedEquities.title = "Unlisted Equities"]]},
    allulequityprices: (state) => state.unlistedEquityPrices,
    allBonds: (state) => state.bonds,
    unconfirmedBonds: (state) => {return [state.bonds.filter(b => b.CheckerID == 0),[state.bonds.title = "Bonds"]]},
    allProperties: (state) => state.properties,
    unconfirmedProperties: (state) => {return [state.properties.filter(b => b.CheckerID == 0),[state.properties.title = "Properties"]]},
    allPropertyValues: (state) => state.propertyValues,
    unconfirmedPropertyValues: (state) => {return [state.propertyValues.filter(b => b.CheckerID == 0),[state.propertyValues.title = "Property Prices"]]},
    allDailyExchanges: (state) => state.dailyExchanges,
    unconfirmedDailyExchanges: (state) => {return [state.dailyExchanges.filter(d => d.CheckerID == 0),[state.dailyExchanges.title = "Exchange Rates"]]},
    allConfirmationSettings: (state) => state.confirmation_settings,
    allDealers: (state) => state.dealers,
    unconfirmedDealers: (state) => {return [state.dealers.filter(d => d.CheckerID == 0),[state.dealers.title = "Dealers"]]},
    allUnitTrustFunds: (state) => state.unitTrustFunds,
    unconfirmedUnitTrustFunds: (state) => {return [state.unitTrustFunds.filter(d => d.CheckerID == 0),[state.unitTrustFunds.title = "Unit Trust Funds"]]},
    allUnitTrustRedemptions: (state) => state.unitTrustDeals.filter(u => u.TransactionCodeID == 57),
    unconfirmedUnitTrustRedemptions: (state) => {return [state.unitTrustDeals.filter(d => d.CheckerID == 0 && d.TransactionCodeID == 57),[state.unitTrustDeals.title = "Unit Trust Redemptions"]]},
    allUnitTrustSubscriptions: (state) => state.unitTrustDeals.filter(u => u.TransactionCodeID == 56),
    unconfirmedUnitTrustSubscriptions: (state) => {return [state.unitTrustDeals.filter(d => d.CheckerID == 0 && d.TransactionCodeID == 56),[state.unitTrustDeals.title = "Unit Trust Subscriptions"]]},
    allUnitDistributions: (state) => state.unitDistributions,
    unconfirmedUnitDistributions: (state) => {return [state.unitDistributions.filter(d => d.CheckerID == 0),[state.unitDistributions.title = "Unit Distributions"]]},
  },

//********************************************************************ACTIONS*****************************************************************************************
//********************************************************************************************************************************************************************

  actions: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// INSTRUMENT TYPES

  createInstrumentType({ commit }, data) {
      return administrationService.createInstrumentType(data).then(
        response => {
          commit('newInstrumentType', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllInstrumentTypes({ commit }) {
      return administrationService.getAllInstrumentTypes().then(
        response => {
          commit('setInstrumentTypes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateInstrumentType({ commit }, data) {
      return administrationService.updateInstrumentType(data.InstrumentTypeID, data).then(
        response => {
          commit('updInstrumentType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteInstrumentType({ commit }, data) {
      return administrationService.deleteInstrumentType(data.InstrumentTypeID).then(
        response => {
          commit('dltInstrumentType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// COUNTER-PARTY LIMITS

  createCounterpartyLimit({ commit }, data) {
      return administrationService.createCounterpartyLimit(data).then(
        response => {
          commit('newCounterpartyLimit', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllCounterpartyLimits({ commit }) {
      return administrationService.getAllCounterpartyLimits().then(
        response => {
          commit('setCounterpartyLimits', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllCounterparties({ commit }) {
      return administrationService.getAllCounterparties().then(
        response => {
          commit('setCounterparties', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateCounterpartyLimit({ commit }, data) {
      return administrationService.updateCounterpartyLimit(data.id, data).then(
        response => {
          commit('updCounterpartyLimit', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteCounterpartyLimit({ commit }, data) {
      return administrationService.deleteCounterpartyLimit(data.id).then(
        response => {
          commit('dltCounterpartyLimit', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEALER LIMITS

  createDealerLimit({ commit }, data) {
      return administrationService.createDealerLimit(data).then(
        response => {
          commit('newDealerLimit', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllDealerLimits({ commit }) {
      return administrationService.getAllDealerLimits().then(
        response => {
          commit('setDealerLimits', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateDealerLimit({ commit }, data) {
      return administrationService.updateDealerLimit(data.id, data).then(
        response => {
          commit('updDealerLimit', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteDealerLimit({ commit }, data) {
      return administrationService.deleteDealerLimit(data.id).then(
        response => {
          commit('dltDealerLimit', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TAX RATES

  createTaxRate({ commit }, data) {
      return administrationService.createTaxRate(data).then(
        response => {
          commit('newTaxRate', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllTaxRates({ commit }) {
      return administrationService.getAllTaxRates().then(
        response => {
          commit('setTaxRates', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateTaxRate({ commit }, data) {
      return administrationService.updateTaxRate(data.TaxRateID, data).then(
        response => {
          commit('updTaxRate', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteTaxRate({ commit }, data) {
      return administrationService.deleteTaxRate(data.TaxRateID).then(
        response => {
          commit('dltTaxRate', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TAXES

  createTax({ commit }, data) {
      return administrationService.createTax(data).then(
        response => {
          commit('newTax', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllTaxes({ commit }) {
      return administrationService.getAllTaxes().then(
        response => {
          commit('setTaxes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateTax({ commit }, data) {
      return administrationService.updateTax(data.TaxID, data).then(
        response => {
          commit('updTax', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteTax({ commit }, data) {
      return administrationService.deleteTax(data.TaxID).then(
        response => {
          commit('dltTax', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MONEY MARKET RATES

  createMMRate({ commit }, data) {
      return administrationService.createMMRate(data).then(
        response => {
          commit('newMMRate', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllMMRates({ commit }) {
      return administrationService.getAllMMRates().then(
        response => {
          commit('setMMRates', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateMMRate({ commit }, data) {
      return administrationService.updateMMRate(data.MMRatesId, data).then(
        response => {
          commit('updMMRate', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteMMRate({ commit }, data) {
      return administrationService.deleteMMRate(data.MMRatesId).then(
        response => {
          commit('dltMMRate', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// KYC DOCUMENTS

    getAllKYCDocuments({ commit }) {
      return administrationService.getKYCDocs().then(
        response => {
          commit('setKYCDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createComDocument({ commit }, data) {
      return administrationService.createComDoc(data).then(
        response => {
          commit('newComDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllComDocuments({ commit }) {
      return administrationService.getAllComDocs().then(
        response => {
          commit('setComDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateComDocument({ commit }, data) {
      return administrationService.updateComDoc(data).then(
        response => {
          commit('updComDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteComDocument({ commit }, data) {
      return administrationService.deleteComDoc(data.ClientId, data).then(
        response => {
          commit('dltComDoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createDecDocument({ commit }, data) {
      return administrationService.createDecDoc(data).then(
        response => {
          commit('newDecDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );        
    },

    getAllDecDocuments({ commit }) {
      return administrationService.getAllDecDocs().then(
        response => {
          commit('setDecDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateDecDocument({ commit }, data) {
      return administrationService.updateDecDoc(data).then(
        response => {
          commit('updDecDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteDecDocument({ commit }, data) {
      return administrationService.deleteDecDoc(data.ClientId, data).then(
        response => {
          commit('dltDecDoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createIndDocument({ commit }, data) {
      return administrationService.createIndDoc(data).then(
        response => {
          commit('newIndDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );        
    },

    getAllIndDocuments({ commit }) {
      return administrationService.getAllIndDocs().then(
        response => {
          commit('setIndDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateIndDocument({ commit }, data) {
      return administrationService.updateIndDoc(data).then(
        response => {
          commit('updIndDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteIndDocument({ commit }, data) {
      return administrationService.deleteIndDoc(data.ClientId, data).then(
        response => {
          commit('dltIndDoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createParDocument({ commit }, data) {
      return administrationService.createParDoc(data).then(
        response => {
          commit('newParDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllParDocuments({ commit }) {
      return administrationService.getAllParDocs().then(
        response => {
          commit('setParDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateParDocument({ commit }, data) {
      return administrationService.updateParDoc(data).then(
        response => {
          commit('updParDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteParDocument({ commit }, data) {
      return administrationService.deleteParDoc(data.ClientId, data).then(
        response => {
          commit('dltParDoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createPenDocument({ commit }, data) {
      return administrationService.createPenDoc(data).then(
        response => {
          commit('newPenDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );        
    },

    getAllPenDocuments({ commit }) {
      return administrationService.getAllPenDocs().then(
        response => {
          commit('setPenDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updatePenDocument({ commit }, data) {
      return administrationService.updatePenDoc(data).then(
        response => {
          commit('updPenDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deletePenDocument({ commit }, data) {
      return administrationService.deletePenDoc(data.ClientId, data).then(
        response => {
          commit('dltPenDoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createTruDocument({ commit }, data) {
      return administrationService.createTruDoc(data).then(
        response => {
          commit('newTruDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllTruDocuments({ commit }) {
      return administrationService.getAllTruDocs().then(
        response => {
          commit('setTruDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateTruDocument({ commit }, data) {
      return administrationService.updateTruDoc(data).then(
        response => {
          commit('updTruDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteTruDocument({ commit }, data) {
      return administrationService.deleteTruDoc(data.ClientId, data).then(
        response => {
          commit('dltTruDoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createRDCDocument({ commit }, data) {
      return administrationService.createRDCDoc(data).then(
        response => {
          commit('newRDCDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllRDCDocuments({ commit }) {
      return administrationService.getAllRDCDocs().then(
        response => {
          commit('setRDCDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateRDCDocument({ commit }, data) {
      return administrationService.updateRDCDoc(data).then(
        response => {
          commit('updRDCDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteRDCDocument({ commit }, data) {
      return administrationService.deleteRDCDoc(data.ClientId, data).then(
        response => {
          commit('dltRDCDoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createPtlDocument({ commit }, data) {
      return administrationService.createPtlDoc(data).then(
        response => {
          commit('newPtlDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllPtlDocuments({ commit }) {
      return administrationService.getAllPtlDocs().then(
        response => {
          commit('setPtlDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updatePtlDocument({ commit }, data) {
      return administrationService.updatePtlDoc(data).then(
        response => {
          commit('updPtlDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deletePtlDocument({ commit }, data) {
      return administrationService.deletePtlDoc(data.ClientId, data).then(
        response => {
          commit('dltPtlDoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createMunDocument({ commit }, data) {
      return administrationService.createMunDoc(data).then(
        response => {
          commit('newMunDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllMunDocuments({ commit }) {
      return administrationService.getAllMunDocs().then(
        response => {
          commit('setMunDocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateMunDocument({ commit }, data) {
      return administrationService.updateMunDoc(data).then(
        response => {
          commit('updMunDoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteMunDocument({ commit }, data) {
      return administrationService.deleteMunDoc(data.ClientId, data).then(
        response => {
          commit('dltMunDoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createNGODocument({ commit }, data) {
      return administrationService.createNGODoc(data).then(
        response => {
          commit('newNGODoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllNGODocuments({ commit }) {
      return administrationService.getAllNGODocs().then(
        response => {
          commit('setNGODocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateNGODocument({ commit }, data) {
      return administrationService.updateNGODoc(data).then(
        response => {
          commit('updNGODoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteNGODocument({ commit }, data) {
      return administrationService.deleteNGODoc(data.ClientId, data).then(
        response => {
          commit('dltNGODoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createCCODocument({ commit }, data) {
      return administrationService.createCCODoc(data).then(
        response => {
          commit('newCCODoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllCCODocuments({ commit }) {
      return administrationService.getAllCCODocs().then(
        response => {
          commit('setCCODocs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateCCODocument({ commit }, data) {
      return administrationService.updateCCODoc(data).then(
        response => {
          commit('updCCODoc', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteCCODocument({ commit }, data) {
      return administrationService.deleteCCODoc(data.ClientId, data).then(
        response => {
          commit('dltCCODoc', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FUND ACCOUNT TYPES

    getAllFundAccountTypes({ commit }) {
      return administrationService.getAllFundAccountTypes().then(
        response => {
          commit('setFundAccountTypes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CLIENTS

  createClient({ commit }, data) {
      return administrationService.createClient(data).then(
        response => {
          commit('newClient', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllClients({ commit }) {
      return administrationService.getAllClients().then(
        response => {
          commit('setClients', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateClient({ commit }, data) {
      return administrationService.updateClient(data.ClientID, data).then(
        response => {
          commit('updClient', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteClient({ commit }, data) {
      return administrationService.deleteClient(data.ClientID).then(
        response => {
          commit('dltClient', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createClientSignatory({ commit }, data) {
      return administrationService.createClientSignatories(data).then(
        response => {
          commit('newClientSignatories', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );        
    },

    getAllClientSignatories({ commit }) {
      return administrationService.getAllClientSignatories().then(
        response => {
          commit('setClientSignatories', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateClientSignatory({ commit }, data) {
      return administrationService.updateClientSignatory(data.json.SignatoryID, data).then(
        response => {
          commit('updClientSignatory', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteClientSignatory({ commit }, data) {
      return administrationService.deleteClientSignatory(data.SignatoryID).then(
        response => {
          commit('dltClientSignatory', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createClientContact({ commit }, data) {
      return administrationService.createClientContacts(data).then(
        response => {
          commit('newClientContact', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );        
    },

    getAllClientContacts({ commit }) {
      return administrationService.getAllClientContacts().then(
        response => {
          commit('setClientContacts', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateClientContact({ commit }, data) {
      return administrationService.updateClientContact(data.ContactID, data).then(
        response => {
          commit('updClientContact', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteClientContact({ commit }, data) {
      return administrationService.deleteClientContact(data.ContactID).then(
        response => {
          commit('dltClientContact', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    createClientAccount({ commit }, data) {
      return administrationService.createClientAccount(data).then(
        response => {
          commit('newClientAccount', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );        
    },

    getAllClientAccounts({ commit }) {
      return administrationService.getAllClientAccounts().then(
        response => {
          commit('setClientAccounts', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateClientAccount({ commit }, data) {
      return administrationService.updateClientAccount(data.AccountID, data).then(
        response => {
          commit('updClientAccount', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteClientAccount({ commit }, data) {
      return administrationService.deleteClientAccount(data.AccountID).then(
        response => {
          commit('dltClientAccount', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FEES MANAGEMENT

  createFee({ commit }, data) {
      return administrationService.createFee(data).then(
        response => {
          commit('newFee', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllFees({ commit }) {
      return administrationService.getAllFees().then(
        response => {
          commit('setFees', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllApplicationModules({ commit }) {
      return administrationService.getAllApplicationModules().then(
        response => {
          commit('setApplicationModules', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateFee({ commit }, data) {
      return administrationService.updateFee(data.FeesId, data).then(
        response => {
          commit('updFee', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteFee({ commit }, data) {
      return administrationService.deleteFee(data.FeesId).then(
        response => {
          commit('dltFee', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TRANSACTION CHARGES

  createTransactionCharge({ commit }, data) {
      return administrationService.createTransactionCharge(data).then(
        response => {
          commit('newTransactionCharge', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllTransactionCharges({ commit }) {
      return administrationService.getAllTransactionCharges().then(
        response => {
          commit('setTransactionCharges', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateTransactionCharge({ commit }, data) {
      return administrationService.updateTransactionCharge(data.TransactionChargeID, data).then(
        response => {
          commit('updTransactionCharge', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteTransactionCharge({ commit }, data) {
      return administrationService.deleteTransactionCharge(data.TransactionChargeID).then(
        response => {
          commit('dltTransactionCharge', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },


  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //COUNTER PARTIES ACTIONS

    createCounterParty({ commit }, data) {
      return administrationService.createCounterParty(data).then(
        response => {
          commit('newCounterParty', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    
    updateCounterParty({ commit }, data) {
      return administrationService.updateCounterParty(data.CounterPartyID, data).then(
        response => {
          commit('updCounterParty', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteCounterParty({ commit }, data) {
      return administrationService.deleteCounterParty(data.CounterPartyID).then(
        response => {
          commit('dltCounterParty', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CUSTODIANS

  createCustodian({ commit }, data) {
      return administrationService.createCustodian(data).then(
        response => {
          commit('newCustodian', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllCustodians({ commit }) {
      return administrationService.getAllCustodians().then(
        response => {
          commit('setCustodians', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllProfileTypes({ commit }) {
      return administrationService.getAllProfileTypes().then(
        response => {
          commit('setProfileTypes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateCustodian({ commit }, data) {
      return administrationService.updateCustodian(data.CustodianID, data).then(
        response => {
          commit('updCustodian', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteCustodian({ commit }, data) {
      return administrationService.deleteCustodian(data.CustodianID).then(
        response => {
          commit('dltCustodian', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//TRANSACTION CHARGE RATE 

    createTransactionchargerate({ commit }, data) {
      return administrationService.createTransactionchargerate(data).then(
        response => {
          commit('newTransactionchargerate', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllTransactionchargerate({ commit }) {
      return administrationService.getAllTransactionchargerate().then(
        response => {
          commit('setTransactionchargerate', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateTransactionchargerate({ commit }, data) {
      return administrationService.updateTransactionchargerate(data.TransactionChargeRateId, data).then(
        response => {
          commit('updTransactionchargerate', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteTransactionchargerate({ commit }, data) {
      return administrationService.deleteTransactionchargerate(data.TransactionChargeRateId).then(
        response => {
          commit('dltTransactionchargerate', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//EQUITIES 

    createEquity({ commit }, data) {
      return administrationService.createEquity(data).then(
        response => {
          commit('newEquity', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllEquities({ commit }) {
      return administrationService.getAllEquities().then(
        response => {
          commit('setEquities', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateEquity({ commit }, data) {
      return administrationService.updateEquity(data.EquityID, data).then(
        response => {
          commit('updEquity', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteEquity({ commit }, data) {
      return administrationService.deleteEquity(data.EquityID).then(
        response => {
          commit('dltEquity', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//EQUITY PRICES

    createEquityprice({ commit }, data) {
      return administrationService.createEquityprice(data).then(
        response => {
          commit('newEquityprice', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllEquityprices({ commit }) {
      return administrationService.getAllEquityprices().then(
        response => {
          commit('setEquityprices', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateEquityprice({ commit }, data) {
      return administrationService.updateEquityprice(data.EquityID, data).then(
        response => {
          commit('updEquityprice', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteEquityprice({ commit }, data) {
      return administrationService.deleteEquityprice(data.EquityID).then(
        response => {
          commit('dltEquityprice', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNLISTED EQUITIES 

    createUlEquity({ commit }, data) {
      return administrationService.createUlEquity(data).then(
        response => {
          commit('newUlEquity', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllUlEquities({ commit }) {
      return administrationService.getAllUlEquities().then(
        response => {
          commit('setUlEquities', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateUlEquity({ commit }, data) {
      return administrationService.updateUlEquity(data.EquityID, data).then(
        response => {
          commit('updUlEquity', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteUlEquity({ commit }, data) {
      return administrationService.deleteUlEquity(data.EquityID).then(
        response => {
          commit('dltUlEquity', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//UNLISTED EQUITY PRICES

    createUlEquityprice({ commit }, data) {
      return administrationService.createUlEquityprice(data).then(
        response => {
          commit('newUlEquityprice', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getAllUlEquityprices({ commit }) {
      return administrationService.getAllUlEquityprices().then(
        response => {
          commit('setUlEquityprices', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateUlEquityprice({ commit }, data) {
      return administrationService.updateEquityprice(data.EquityID, data).then(
        response => {
          commit('updUlEquityprice', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteUlEquityprice({ commit }, data) {
      return administrationService.deleteEquityprice(data.EquityID).then(
        response => {
          commit('dltUlEquityprice', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    getApplicationFunctions({ commit }) {
      return administrationService.getApplicationFunctions().then(
        response => {
          commit('setApplicationFunctions', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    getStockExchanges({ commit }) {
      return administrationService.getStockExchanges().then(
        response => {
          commit('setStockExchanges', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// APPLICATION EVENTS

  createEvent({ commit }, data) {
    return administrationService.createEvent(data).then(
      response => {
        commit('newEvent', response.data);
        return Promise.resolve(response);
      },
      error => {
        return Promise.reject(error);
      }
    );
  },
  getAllEvents({ commit }) {
    return administrationService.getAllEvents().then(
      response => {
        commit('setEvents', response.data);
        return Promise.resolve(response);
      },
      error => {
        return Promise.reject(error);
      }
    );
  },
  updateEvent({ commit }, data) {
    return administrationService.updateEvent(data.EventId, data).then(
      response => {
        commit('updEvent', data);
        return Promise.resolve(response);
      },
      error => {
        return Promise.reject(error);
      }
    );
  },

  deleteEvent({ commit }, data) {
    return administrationService.deleteEvent(data.EventId).then(
      response => {
        commit('dltEvent', data);
        return Promise.resolve(response);
      },
      error => {
        return Promise.reject(error);
      }
    );
  },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EVENT MAPPINGS

  createEventMapping({ commit }, data) {
      return administrationService.createEventMapping(data).then(
        response => {
          commit('newEventMapping', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllEventMappings({ commit }) {
      return administrationService.getAllEventMappings().then(
        response => {
          commit('setEventMappings', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateEventMapping({ commit }, data) {
      return administrationService.updateEventMapping(data.EventMappingId, data).then(
        response => {
          commit('updEventMapping', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteEventMapping({ commit }, data) {
      return administrationService.deleteEventMapping(data.EventMappingId).then(
        response => {
          commit('dltEventMapping', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BONDS

  createBond({ commit }, data) {
      return administrationService.createBond(data).then(
        response => {
          commit('newBond', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    retrieveBonds({ commit }) {
      return administrationService.getAllBonds().then(
        response => {
          commit('setBonds', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateBondStatus({ commit }, data) {
      return administrationService.updateBondStatus(data.BondID, data).then(
        response => {
          commit('updBond', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateBond({ commit }, data) {
      return administrationService.updateBond(data.BondID, data).then(
        response => {
          commit('updBond', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteBond({ commit }, data) {
      return administrationService.deleteBond(data.BondID).then(
        response => {
          commit('dltBond', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROPERTIES

  createProperty({ commit }, data) {
      return administrationService.createProperty(data).then(
        response => {
          commit('newProperty', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    retrieveProperties({ commit }) {
      return administrationService.getAllProperties().then(
        response => {
          commit('setProperties', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updatePropertyStatus({ commit }, data) {
      return administrationService.updatePropertyStatus(data.PropertyID, data).then(
        response => {
          commit('updProperty', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateProperty({ commit }, data) {
      return administrationService.updateProperty(data.PropertyID, data).then(
        response => {
          commit('updProperty', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteProperty({ commit }, data) {
      return administrationService.deleteProperty(data.PropertyID).then(
        response => {
          commit('dltProperty', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROPERTY VALUES

createPropertyValues({ commit }, data) {
  return administrationService.createPropertyValues(data).then(
    response => {
      console.log("Property Values: " + response.data.values[0])
      commit('newPropertyValues', response.data);
      return Promise.resolve(response);
    },
    error => {
      return Promise.reject(error);
    }
  );
},

retrievePropertyValues({ commit }) {
  return administrationService.getAllPropertyValues().then(
    response => {
      commit('setPropertyValues', response.data);
      return Promise.resolve(response);
    },
    error => {
      return Promise.reject(error);
    }
  );
},

updatePropertyValuesStatus({ commit }, data) {
  return administrationService.updatePropertyValuesStatus(data).then(
    response => {
      commit('updPropertyValues', data);
      return Promise.resolve(response);
    },
    error => {
      return Promise.reject(error);
    }
  );
},

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DAILY EXCHANGES

    createDailyExchange({ commit }, data) {
      return administrationService.createDailyExchange(data).then(
        response => {
          commit('newDailyExchange', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    retrieveDailyExchanges({ commit }) {
      return administrationService.getAllDailyExchanges().then(
        response => {
          commit('setDailyExchanges', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateDailyExchange({ commit }, data) {
      return administrationService.updateDailyExchange(data.DailyExchangeId, data).then(
        response => {
          commit('updDailyExchange', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteDailyExchange({ commit }, data) {
      return administrationService.deleteDailyExchange(data.DailyExchangeId).then(
        response => {
          commit('dltDailyExchange', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CONFIRMATION SETTINGS

    retrieveConfirmationSettings({ commit }) {
      return administrationService.getAllConfirmationSettings().then(
        response => {
          commit('setConfirmationSettings', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateConfirmationSettings({ commit }, data) {
      return administrationService.updateConfirmationSettings(data).then(
        response => {
          commit('updConfirmationSettings', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEALERS

    createDealer({ commit }, data) {
      return administrationService.createDealer(data).then(
        response => {
          commit('newDealer', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    retrieveDealers({ commit }) {
      return administrationService.getDealers().then(
        response => {
          commit('setDealers', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateDealer({ commit }, data) {
      return administrationService.updateDealer(data.DealerID, data).then(
        response => {
          commit('updDealer', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteDealer({ commit }, data) {
      return administrationService.deleteDealer(data.DealerID).then(
        response => {
          commit('dltDealer', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT TRUST FUNDS

    createUnitTrustFund({ commit }, data) {
      return administrationService.createUnitTrustFund(data).then(
        response => {
          commit('newUnitTrustFund', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    retrieveUnitTrustFunds({ commit }) {
      return administrationService.getUnitTrustFunds().then(
        response => {
          commit('setUnitTrustFunds', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateUnitTrustFundStatus({ commit }, data) {
      return administrationService.updateUnitTrustFundStatus(data.UnitTrustFundId, data).then(
        response => {
          commit('updUnitTrustFund', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateUnitTrustFund({ commit }, data) {
      return administrationService.updateUnitTrustFund(data.UnitTrustFundId, data).then(
        response => {
          commit('updUnitTrustFund', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteUnitTrustFund({ commit }, data) {
      return administrationService.deleteUnitTrustFund(data.UnitTrustFundId).then(
        response => {
          commit('dltUnitTrustFund', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT TRUST DEALS

    createUnitTrustDeal({ commit }, data) {
      return administrationService.createUnitTrustDeal(data).then(
        response => {
          commit('newUnitTrustDeal', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    retrieveUnitTrustDeals({ commit }) {
      return administrationService.getUnitTrustDeals().then(
        response => {
          commit('setUnitTrustDeals', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateUnitTrustDealStatus({ commit }, data) {
      return administrationService.updateUnitTrustDealStatus(data.DealNumber, data).then(
        response => {
          commit('updUnitTrustDeal', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateUnitTrustDeal({ commit }, data) {
      return administrationService.updateUnitTrustDeal(data.DealNumber, data).then(
        response => {
          commit('updUnitTrustDeal', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteUnitTrustDeal({ commit }, data) {
      return administrationService.deleteUnitTrustDeal(data.DealNumber).then(
        response => {
          commit('dltUnitTrustDeal', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT DISTRIBUTIONS

    createUnitDistribution({ commit }, data) {
      return administrationService.createUnitDistribution(data).then(
        response => {
          commit('newUnitDistribution', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    retrieveUnitDistributions({ commit }) {
      return administrationService.getUnitDistributions().then(
        response => {
          commit('setUnitDistributions', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateUnitDistributionStatus({ commit }, data) {
      return administrationService.updateUnitDistributionStatus(data.UnitsDistributionsId, data.CheckerID, data).then(
        response => {
          commit('updUnitDistribution', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    updateUnitDistribution({ commit }, data) {
      return administrationService.updateUnitDistribution(data.DealNumber, data).then(
        response => {
          commit('updUnitDistribution', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

    deleteUnitDistribution({ commit }, data) {
      return administrationService.deleteUnitDistribution(data.DealNumber).then(
        response => {
          commit('dltUnitDistribution', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
  },

//********************************************************************MUTATIONS***************************************************************************************
//********************************************************************************************************************************************************************
  mutations: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// INSTRUMENT TYPES

    setInstrumentTypes: (state, instrumentTypes) => (state.instrumentTypes = instrumentTypes),
    newInstrumentType: (state, newInstrumentType) => state.instrumentTypes.unshift(newInstrumentType.instrument_type),
    updInstrumentType: (state, updatedInstrumentType) => {
      const index = state.instrumentTypes.findIndex(instrumentTypes => instrumentTypes.InstrumentTypeID === updatedInstrumentType.InstrumentTypeID);
      if (index !== -1) {
        state.instrumentTypes.splice(index, 1, updatedInstrumentType);
      }
    },
    dltInstrumentType: (state, InstrumentType) => {
      const index = state.instrumentTypes.findIndex(instrumentTypes => instrumentTypes.InstrumentTypeID === InstrumentType.InstrumentTypeID);
      if (index !== -1) {
        state.instrumentTypes.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// COUNTER-PARTY LIMITS

    setCounterpartyLimits: (state, counterpartyLimits) => (state.counterpartyLimits = counterpartyLimits),
    setCounterparties: (state, counterparties) => (state.counterparties = counterparties),
    newCounterpartyLimit: (state, newLimit) => state.counterpartyLimits.unshift(newLimit.counterparty_limit),
    updCounterpartyLimit: (state, updatedLimit) => {
      const index = state.counterpartyLimits.findIndex(counterpartyLimits => counterpartyLimits.id === updatedLimit.id);
      if (index !== -1) {
        state.counterpartyLimits.splice(index, 1, updatedLimit);
      }
    },
    dltCounterpartyLimit: (state, Limit) => {
      const index = state.counterpartyLimits.findIndex(counterpartyLimits => counterpartyLimits.id === Limit.id);
      if (index !== -1) {
        state.counterpartyLimits.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEALER LIMITS

    setDealerLimits: (state, dealerLimits) => (state.dealerLimits = dealerLimits),
    newDealerLimit: (state, newLimit) => state.dealerLimits.unshift(newLimit.dealer_limit),
    updDealerLimit: (state, updatedLimit) => {
      const index = state.dealerLimits.findIndex(dealerLimits => dealerLimits.id === updatedLimit.id);
      if (index !== -1) {
        state.dealerLimits.splice(index, 1, updatedLimit);
      }
    },
    dltDealerLimit: (state, Limit) => {
      const index = state.dealerLimits.findIndex(dealerLimits => dealerLimits.id === Limit.id);
      if (index !== -1) {
        state.dealerLimits.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TAX RATES

    setTaxRates: (state, taxRates) => (state.taxRates = taxRates),
    newTaxRate: (state, newTaxRate) => state.taxRates.unshift(newTaxRate.tax_rate),
    updTaxRate: (state, updatedTaxRate) => {
      const index = state.taxRates.findIndex(taxRates => taxRates.TaxRateID === updatedTaxRate.TaxRateID);
      if (index !== -1) {
        state.taxRates.splice(index, 1, updatedTaxRate);
      }
    },
    dltTaxRate: (state, TaxRate) => {
      const index = state.taxRates.findIndex(taxRates => taxRates.TaxRateID === TaxRate.TaxRateID);
      if (index !== -1) {
        state.taxRates.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TAXES

    setTaxes: (state, taxes) => (state.taxes = taxes),
    newTax: (state, newTax) => state.taxes.unshift(newTax.tax),
    updTax: (state, updatedTax) => {
      const index = state.taxes.findIndex(taxes => taxes.TaxID === updatedTax.TaxID);
      if (index !== -1) {
        state.taxes.splice(index, 1, updatedTax);
      }
    },
    dltTax: (state, Tax) => {
      const index = state.taxes.findIndex(taxes => taxes.TaxID === Tax.TaxID);
      if (index !== -1) {
        state.taxes.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MONEY MARKET RATES

    setMMRates: (state, rates) => (state.mmRates = rates),
    newMMRate: (state, newRate) => state.mmRates.unshift(newRate.rate),
    updMMRate: (state, updatedRate) => {
      const index = state.mmRates.findIndex(r => r.MMRatesId === updatedRate.MMRatesId);
      if (index !== -1) {
        state.mmRates.splice(index, 1, updatedRate);
      }
    },
    dltMMRate: (state, Rate) => {
      const index = state.mmRates.findIndex(r => r.MMRatesId === Rate.MMRatesId);
      if (index !== -1) {
        state.mmRates.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// KYC DOCUMENTS

    setKYCDocs: (state, Docs) => (state.kycDocuments = Docs),

    newComDoc: (state, newComDoc) => {state.comDocuments.unshift(newComDoc.doc); state.kycDocuments.unshift(newComDoc.file)},
    setComDocs: (state, ComDocs) => (state.comDocuments = ComDocs),
    updComDoc: (state, updatedDoc) => {
      const index = state.comDocuments.findIndex(comDocuments => comDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.comDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltComDoc: (state, updatedDoc) => {
      const index = state.comDocuments.findIndex(comDocuments => comDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.comDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newDecDoc: (state, newDecDoc) => {state.decDocuments.unshift(newDecDoc.doc); state.kycDocuments.unshift(newDecDoc.file)},
    setDecDocs: (state, DecDocs) => (state.decDocuments = DecDocs),
    updDecDoc: (state, updatedDoc) => {
      const index = state.decDocuments.findIndex(decDocuments => decDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.decDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltDecDoc: (state, updatedDoc) => {
      const index = state.decDocuments.findIndex(decDocuments => decDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.decDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newIndDoc: (state, newIndDoc) => {state.indDocuments.unshift(newIndDoc.doc); state.kycDocuments.unshift(newIndDoc.file)},
    setIndDocs: (state, IndDocs) => (state.indDocuments = IndDocs),
    updIndDoc: (state, updatedDoc) => {
      const index = state.indDocuments.findIndex(indDocuments => indDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.indDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltIndDoc: (state, updatedDoc) => {
      const index = state.indDocuments.findIndex(indDocuments => indDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.indDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newParDoc: (state, newParDoc) => {state.parDocuments.unshift(newParDoc.doc); state.kycDocuments.unshift(newParDoc.file)},
    setParDocs: (state, ParDocs) => (state.parDocuments = ParDocs),
    updParDoc: (state, updatedDoc) => {
      const index = state.parDocuments.findIndex(parDocuments => parDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.parDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltParDoc: (state, updatedDoc) => {
      const index = state.parDocuments.findIndex(parDocuments => parDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.parDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newPenDoc: (state, newPenDoc) => {state.penDocuments.unshift(newPenDoc.doc), state.kycDocuments.unshift(newPenDoc.file)},
    setPenDocs: (state, PenDocs) => (state.penDocuments = PenDocs),
    updPenDoc: (state, updatedDoc) => {
      const index = state.penDocuments.findIndex(penDocuments => penDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.penDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltPenDoc: (state, updatedDoc) => {
      const index = state.penDocuments.findIndex(penDocuments => penDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.penDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newTruDoc: (state, newTruDoc) => {state.truDocuments.unshift(newTruDoc.doc), state.kycDocuments.unshift(newTruDoc.file)},
    setTruDocs: (state, TruDocs) => (state.truDocuments = TruDocs),
    updTruDoc: (state, updatedDoc) => {
      const index = state.truDocuments.findIndex(truDocuments => truDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.truDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltTruDoc: (state, updatedDoc) => {
      const index = state.truDocuments.findIndex(truDocuments => truDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.truDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newRDCDoc: (state, newRDCDoc) => {state.rdcDocuments.unshift(newRDCDoc.doc), state.kycDocuments.unshift(newRDCDoc.file)},
    setRDCDocs: (state, RDCDocs) => (state.rdcDocuments = RDCDocs),
    updRDCDoc: (state, updatedDoc) => {
      const index = state.rdcDocuments.findIndex(rdcDocuments => rdcDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.rdcDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltRDCDoc: (state, updatedDoc) => {
      const index = state.rdcDocuments.findIndex(rdcDocuments => rdcDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.rdcDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newPtlDoc: (state, newPtlDoc) => {state.ptlDocuments.unshift(newPtlDoc.doc), state.kycDocuments.unshift(newPtlDoc.file)},
    setPtlDocs: (state, PtlDocs) => (state.ptlDocuments = PtlDocs),
    updPtlDoc: (state, updatedDoc) => {
      const index = state.ptlDocuments.findIndex(ptlDocuments => ptlDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.ptlDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltPtlDoc: (state, updatedDoc) => {
      const index = state.ptlDocuments.findIndex(ptlDocuments => ptlDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.ptlDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newMunDoc: (state, newMunDoc) => {state.munDocuments.unshift(newMunDoc.doc), state.kycDocuments.unshift(newMunDoc.file)},
    setMunDocs: (state, MunDocs) => (state.munDocuments = MunDocs),
    updMunDoc: (state, updatedDoc) => {
      const index = state.munDocuments.findIndex(munDocuments => munDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.munDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltMunDoc: (state, updatedDoc) => {
      const index = state.munDocuments.findIndex(munDocuments => munDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.munDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newNGODoc: (state, newNGODoc) => {state.ngoDocuments.unshift(newNGODoc.doc), state.kycDocuments.unshift(newNGODoc.file)},
    setNGODocs: (state, NGODocs) => (state.ngoDocuments = NGODocs),
    updNGODoc: (state, updatedDoc) => {
      const index = state.ngoDocuments.findIndex(ngoDocuments => ngoDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.ngoDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltNGODoc: (state, updatedDoc) => {
      const index = state.ngoDocuments.findIndex(ngoDocuments => ngoDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.ngoDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },
    newCCODoc: (state, newCCODoc) => {state.ccoDocuments.unshift(newCCODoc.doc), state.kycDocuments.unshift(newCCODoc.file)},
    setCCODocs: (state, CCODocs) => (state.ccoDocuments = CCODocs),
    updCCODoc: (state, updatedDoc) => {
      const index = state.ccoDocuments.findIndex(ccoDocuments => ccoDocuments.ClientId === updatedDoc.doc.ClientId);
      if (index !== -1) {
        state.ccoDocuments.splice(index, 1, updatedDoc.doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.ClientID === updatedDoc.file.ClientID && k.DocType == updatedDoc.file.DocType && k.IsCurrent == true);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
      state.kycDocuments.unshift(updatedDoc.file);
    },
    dltCCODoc: (state, updatedDoc) => {
      const index = state.ccoDocuments.findIndex(ccoDocuments => ccoDocuments.ClientId === updatedDoc.ClientId);
      if (index !== -1) {
        state.ccoDocuments.splice(index, 1, updatedDoc.Doc);
      }
      const index2 = state.kycDocuments.findIndex(k => k.FileName === updatedDoc.filename);
      if (index2 !== -1) {
        state.kycDocuments.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FUND ACCOUNT TYPES

    setFundAccountTypes: (state, FundAccountTypes) => (state.fundAccountTypes = FundAccountTypes),

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CLIENTS

    newClient: (state, newClient) => state.clients.unshift(newClient.client),
    setClients: (state, clients) => (state.clients = clients),
    updClient: (state, updatedClient) => {
      updatedClient.exceptions = [];
      for(let i =  0; i < updatedClient.trading_exceptions.length; i++){
        updatedClient.exceptions.push({CounterId: updatedClient.trading_exceptions[i]})
      }
      const index = state.clients.findIndex(clients => clients.ClientID === updatedClient.ClientID);
      if (index !== -1) {
        state.clients.splice(index, 1, updatedClient);
      }
    },
    dltClient: (state, Client) => {
      const index = state.clients.findIndex(clients => clients.ClientID === Client.ClientID);
      if (index !== -1) {
        state.clients.splice(index, 1);
      }
    },
    newClientContact: (state, newContact) => state.clientContacts.unshift(newContact.contact),
    setClientContacts: (state, contacts) => (state.clientContacts = contacts),
    updClientContact: (state, updatedContact) => {
      const index = state.clientContacts.findIndex(clientContacts => clientContacts.ContactID === updatedContact.ContactID);
      if (index !== -1) {
        state.clientContacts.splice(index, 1, updatedContact);
      }
    },
    dltClientContact: (state, Contact) => {
      const index = state.clientContacts.findIndex(clientContacts => clientContacts.ContactID === Contact.ContactID);
      if (index !== -1) {
        state.clientContacts.splice(index, 1);
      }
    },
    newClientSignatories: (state, newSignatory) => state.clientSignatories.unshift(newSignatory.signatory),
    setClientSignatories: (state, signatories) => (state.clientSignatories = signatories),
    updClientSignatory: (state, updatedSignatory) => {
      const index = state.clientSignatories.findIndex(clientSignatories => clientSignatories.SignatoryID === updatedSignatory.signatory.SignatoryID);
      if (index !== -1) {
        state.clientSignatories.splice(index, 1, updatedSignatory.signatory);
      }
    },
    dltClientSignatory: (state, Signatory) => {
      const index = state.clientSignatories.findIndex(clientSignatories => clientSignatories.SignatoryID === Signatory.SignatoryID);
      if (index !== -1) {
        state.clientSignatories.splice(index, 1);
      }
    },
    newClientAccount: (state, newAccount) => state.clientAccounts.unshift(newAccount.account),
    setClientAccounts: (state, clientAccounts) => (state.clientAccounts = clientAccounts),
    updClientAccount: (state, updatedAccount) => {
      const index = state.clientAccounts.findIndex(clientAccounts => clientAccounts.AccountID === updatedAccount.AccountID);
      if (index !== -1) {
        state.clientAccounts.splice(index, 1, updatedAccount);
      }
    },
    dltClientAccount: (state, Account) => {
      const index = state.clientAccounts.findIndex(clientAccounts => clientAccounts.AccountID === Account.AccountID);
      if (index !== -1) {
        state.clientAccounts.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FEES MANAGEMENT

    setFees: (state, fees) => (state.fees = fees),
    setApplicationModules: (state, applicationModules) => (state.applicationModules = applicationModules),
    newFee: (state, newFee) => state.fees.unshift(newFee.fee),
    updFee: (state, updatedFee) => {
      const index = state.fees.findIndex(fees => fees.FeesId === updatedFee.FeesId);
      if (index !== -1) {
        state.fees.splice(index, 1, updatedFee);
      }
    },
    dltFee: (state, Fee) => {
      const index = state.fees.findIndex(fees => fees.FeesId === Fee.FeesId);
      if (index !== -1) {
        state.fees.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TRANSACTION CHARGES

    setTransactionCharges: (state, charges) => (state.transactionCharges = charges),
    newTransactionCharge: (state, newCharge) => state.transactionCharges.unshift(newCharge.transaction_charge),
    updTransactionCharge: (state, updatedCharge) => {
      const index = state.transactionCharges.findIndex(transactionCharges => transactionCharges.TransactionChargeID === updatedCharge.TransactionChargeID);
      if (index !== -1) {
        state.transactionCharges.splice(index, 1, updatedCharge);
      }
    },
    dltTransactionCharge: (state, Charge) => {
      const index = state.transactionCharges.findIndex(transactionCharges => transactionCharges.TransactionChargeID === Charge.TransactionChargeID);
      if (index !== -1) {
        state.transactionCharges.splice(index, 1);
      }
    },

/////////////////////////////////////////////////////////////////////////////////////////////////
//COUNTER PARTIES 

    // setCounterParty: (state, counterParties) => (state.counterparties = counterParties),
    newCounterParty: (state, newCounterParty) => state.counterparties.unshift(newCounterParty.counterparty),
    updCounterParty: (state, updatedCounterParty) => {
      const index = state.counterparties.findIndex(counterparties => counterparties.CounterPartyID === updatedCounterParty.CounterPartyID);
      if (index !== -1) {
        state.counterparties.splice(index, 1, updatedCounterParty);
      }
    },
    dltCounterParty: (state, CounterParty) => {
      const index = state.counterparties.findIndex(counterParties => counterParties.CounterPartyID === CounterParty.CounterPartyID);
      if (index !== -1) {
        state.counterparties.splice(index, 1);
      }
    },

/////////////////////////////////////////////////////////////////////////////////
//CUSTODIANS

    setCustodians: (state, custodians) => (state.custodians = custodians),
    setProfileTypes: (state, profiles) => (state.profileTypes = profiles),
    newCustodian: (state, newCustodian) => state.custodians.unshift(newCustodian.tblcustodians1),
    updCustodian: (state, updatedCustodian) =>{
    const index = state.custodians.findIndex(custodians => custodians.CustodianID === updatedCustodian.CustodianID);
      if (index !== -1) {
        state.custodians.splice(index, 1, updatedCustodian);
      }
    },
    dltCustodian: (state, custodian) => {
    const index = state.custodians.findIndex(custodians => custodians.CustodianID === custodian.CustodianID);
      if (index !== -1) {
        state.custodians.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TRANSACTION CHARGE RATES 

    setTransactionchargerate : (state, transactionchargerates) => (state.transactionchargerates = transactionchargerates),
    newTransactionchargerate: (state, newTransactionchargerate) => state.transactionchargerates.unshift(newTransactionchargerate.transactionting),
    updTransactionchargerate: (state, updatedTransaction) => {
    const index = state.transactionchargerates.findIndex(transactionchargerates => transactionchargerates.TransactionChargeRateId === updatedTransaction.TransactionChargeRateId);
      if (index !== -1) {
        state.transactionchargerates.splice(index, 1, updatedTransaction);
      }
    },
    dltTransactionchargerate: (state, Transaction1) => {
    const index = state.transactionchargerates.findIndex(transactionchargerates => transactionchargerates.TransactionChargeRateId === Transaction1.TransactionChargeRateId);
      if (index !== -1) {
        state.transactionchargerates.splice(index, 1);
      }
    },

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EQUITIES

    setEquities: (state, newequities) => (state.equities = newequities),
    newEquity: (state, newEquity) => state.equities.unshift(newEquity.lkpequities1),
    updEquity: (state, updatedEquity) => {
    const index = state.equities.findIndex(equities => equities.EquityID === updatedEquity.EquityID);
      if (index !== -1) {
        state.equities.splice(index, 1, updatedEquity);
      }
    },
    dltEquity: (state, equity) => {
    const index = state.equities.findIndex(equities => equities.EquityID === equity.EquityID);
      if (index !== -1) {
        state.equities.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EQUITY PRICES

    setEquityprices: (state, Equityprices) => (state.equityprices = Equityprices),
    newEquityprice: (state, newEquityprice) => {
      for(let i = 0; i < newEquityprice.prices.length; i++){
        state.equityprices.unshift(newEquityprice.prices[i])
      }
    },
    updEquityprice: (state, updatedEquityprice) => {
    const index = state.equityprices.findIndex(equityprices => equityprices.EquityID === updatedEquityprice.EquityID);
      if (index !== -1) {
        state.equityprices.splice(index, 1, updatedEquityprice);
      }
    },
    dltEquityprice: (state, equityp) => {
    const index = state.equityprices.findIndex(equityprices => equityprices.EquityID === equityp.EquityID);
      if (index !== -1) {
        state.equityprices.splice(index, 1);
      }
    },

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNLISTED EQUITIES

    setUlEquities: (state, newequities) => (state.unlistedEquities = newequities),
    newUlEquity: (state, newEquity) => state.unlistedEquities.unshift(newEquity.ul_equity),
    updUlEquity: (state, updatedEquity) => {
    const index = state.unlistedEquities.findIndex(u => u.EquityID === updatedEquity.EquityID);
      if (index !== -1) {
        state.unlistedEquities.splice(index, 1, updatedEquity);
      }
    },
    dltUlEquity: (state, equity) => {
    const index = state.unlistedEquities.findIndex(u => u.EquityID === equity.EquityID);
      if (index !== -1) {
        state.unlistedEquities.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNLISTED EQUITY PRICES

    setUlEquityprices: (state, Equityprices) => (state.unlistedEquityPrices = Equityprices),
    newUlEquityprice: (state, newEquityprice) => {
      for(let i = 0; i < newEquityprice.prices.length; i++){
        state.unlistedEquityPrices.unshift(newEquityprice.prices[i])
      }
    },
    updUlEquityprice: (state, updatedEquityprice) => {
    const index = state.equityprices.findIndex(equityprices => equityprices.EquityID === updatedEquityprice.EquityID);
      if (index !== -1) {
        state.equityprices.splice(index, 1, updatedEquityprice);
      }
    },
    dltUlEquityprice: (state, equityp) => {
    const index = state.equityprices.findIndex(equityprices => equityprices.EquityID === equityp.EquityID);
      if (index !== -1) {
        state.equityprices.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    setApplicationFunctions: (state, Functions) => (state.applicationFunctions = Functions),
    setStockExchanges: (state, stockex) => (state.stockExchanges = stockex),

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// APPLICATION EVENTS

    setEvents: (state, events) => (state.applicationEvents = events),
    newEvent: (state, newEvent) => state.applicationEvents.unshift(newEvent.event),
    updEvent: (state, updatedEvent) => {
      const index = state.applicationEvents.findIndex(applicationEvents => applicationEvents.EventId === updatedEvent.EventId);
      if (index !== -1) {
        state.applicationEvents.splice(index, 1, updatedEvent);
      }
    },
    dltEvent: (state, Event) => {
      const index = state.applicationEvents.findIndex(applicationEvents => applicationEvents.EventId === Event.EventId);
      if (index !== -1) {
        state.applicationEvents.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EVENT MAPPINGS

    setEventMappings: (state, event_mapping) => (state.eventMappings = event_mapping),
    newEventMapping: (state, newEventMapping) => state.eventMappings.unshift(newEventMapping.event_mapping),
    updEventMapping: (state, updatedEventMapping) => {
      const index = state.eventMappings.findIndex(eventMappings => eventMappings.EventMappingId === updatedEventMapping.EventMappingId);
      if (index !== -1) {
        state.eventMappings.splice(index, 1, updatedEventMapping);
      }
    },
    dltEventMapping: (state, EventMapping) => {
      const index = state.eventMappings.findIndex(eventMappings => eventMappings.EventMappingId === EventMapping.EventMappingId);
      if (index !== -1) {
        state.eventMappings.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BONDS

    setBonds: (state, bonds) => (state.bonds = bonds),
    newBond: (state, newBond) => state.bonds.unshift(newBond.bond),
    updBond: (state, updatedBond) => {
      const index = state.bonds.findIndex(bonds => bonds.BondID === updatedBond.BondID);
      if (index !== -1) {
        state.bonds.splice(index, 1, updatedBond);
      }
    },
    dltBond: (state, Bond) => {
      const index = state.bonds.findIndex(bonds => bonds.BondID === Bond.BondID);
      if (index !== -1) {
        state.bonds.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROPERTIES

    setProperties: (state, properties) => (state.properties = properties),
    newProperty: (state, newProperty) => state.properties.unshift(newProperty.property),
    updProperty: (state, updatedProperty) => {
      const index = state.properties.findIndex(p => p.PropertyID === updatedProperty.PropertyID);
      if (index !== -1) {
        state.properties.splice(index, 1, updatedProperty);
      }
    },
    dltProperty: (state, Property) => {
      const index = state.properties.findIndex(p => p.PropertyID === Property.PropertyID);
      if (index !== -1) {
        state.properties.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROPERTY VALUES

    setPropertyValues: (state, values) => (state.propertyValues = values),
    newPropertyValues: (state, newValues) => {
      for(let i = 0; i < newValues.values.length; i++){
        state.propertyValues.unshift(newValues.values[i])      
      }
    },
    updPropertyValues: (state, updatedPropertyValues) => {
      for(let i = 0; i < updatedPropertyValues.length; i++){
        var index = state.propertyValues.findIndex(p => p.ValuationId === updatedPropertyValues[i].ValuationId);
        if (index !== -1) {
          state.propertyValues.splice(index, 1, updatedPropertyValues[i]);
        }        
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DAILY EXCHANGES

    setDailyExchanges: (state, exchanges) => (state.dailyExchanges = exchanges),
    newDailyExchange: (state, newExchange) => state.dailyExchanges.unshift(newExchange.exchange),
    updDailyExchange: (state, updatedExchange) => {
      const index = state.dailyExchanges.findIndex(dailyExchanges => dailyExchanges.DailyExchangeId === updatedExchange.DailyExchangeId);
      if (index !== -1) {
        state.dailyExchanges.splice(index, 1, updatedExchange);
      }
    },
    dltDailyExchange: (state, exchange) => {
      const index = state.dailyExchanges.findIndex(dailyExchanges => dailyExchanges.DailyExchangeId === exchange.DailyExchangeId);
      if (index !== -1) {
        state.dailyExchanges.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CONFIRMATION SETTINGS

    setConfirmationSettings: (state, settings) => (state.confirmation_settings = settings),
    updConfirmationSettings: (state, updatedSettings) => {
      for(let i = 0; i < updatedSettings.load.length; i++){
        const index = state.confirmation_settings.findIndex(c => c.ConfirmationSettingsID === updatedSettings.load[i].ConfirmationSettingsID);
        if (index !== -1) {
          state.confirmation_settings.splice(index, 1, updatedSettings.load[i]);
        }        
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEALERS

    setDealers: (state, dealers) => (state.dealers = dealers),
    newDealer: (state, newDealer) => state.dealers.unshift(newDealer.dealer),
    updDealer: (state, updatedDealer) => {
      const index = state.dealers.findIndex(d => d.DealerID === updatedDealer.DealerID);
      if (index !== -1) {
        state.dealers.splice(index, 1, updatedDealer);
      }
    },
    dltDealer: (state, dealer) => {
      const index = state.dealers.findIndex(d => d.DealerID === dealer.DealerID);
      if (index !== -1) {
        state.dealers.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT TRUST FUNDS

    setUnitTrustFunds: (state, funds) => (state.unitTrustFunds = funds),
    newUnitTrustFund: (state, newFund) => state.unitTrustFunds.unshift(newFund.fund),
    updUnitTrustFund: (state, updatedFund) => {
      const index = state.unitTrustFunds.findIndex(f => f.UnitTrustFundId === updatedFund.UnitTrustFundId);
      if (index !== -1) {
        state.unitTrustFunds.splice(index, 1, updatedFund);
      }
    },
    dltUnitTrustFund: (state, fund) => {
      const index = state.unitTrustFunds.findIndex(f => f.UnitTrustFundId === fund.UnitTrustFundId);
      if (index !== -1) {
        state.unitTrustFunds.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT TRUST DEALS

    setUnitTrustDeals: (state, deals) => (state.unitTrustDeals = deals),
    newUnitTrustDeal: (state, newDeal) => state.unitTrustDeals.unshift(newDeal.deal),
    updUnitTrustDeal: (state, updatedDeal) => {
      const index = state.unitTrustDeals.findIndex(f => f.DealNumber === updatedDeal.DealNumber);
      if (index !== -1) {
        state.unitTrustDeals.splice(index, 1, updatedDeal);
      }
    },
    dltUnitTrustDeal: (state, deal) => {
      const index = state.unitTrustDeals.findIndex(f => f.DealNumber === deal.DealNumber);
      if (index !== -1) {
        state.unitTrustDeals.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT DISTRIBUTIONS

    setUnitDistributions: (state, distribution) => (state.unitDistributions = distribution),
    newUnitDistribution: (state, newDistribution) => state.unitDistributions.unshift(newDistribution.details),
    updUnitDistribution: (state, updatedDistribution) => {
      const index = state.unitDistributions.findIndex(f => f.UnitsDistributionsId === updatedDistribution.UnitsDistributionsId);
      if (index !== -1) {
        state.unitDistributions.splice(index, 1, updatedDistribution);
      }
    },
    dltUnitDistribution: (state, distribution) => {
      const index = state.unitDistributions.findIndex(f => f.UnitsDistributionsId === distribution.UnitsDistributionsId);
      if (index !== -1) {
        state.unitDistributions.splice(index, 1);
      }
    },
  },
}
